import React from "react";
import "./NoGames.scss";
import { useNavigate } from "react-router-dom";

const NoGames = () => {
  const navigate = useNavigate();
  return (
    <div className="no-games-container">
      <h1 className="heading">Looks like no games are open right now!</h1>
      <p className="subtext">
        But hey, why wait? <br />
        Start your own game and let others join in.
      </p>
      <button
        className="book-game-btn"
        onClick={() => {
          navigate("/dashboard/reserve");
        }}
      >
        Book your Game
      </button>
    </div>
  );
};

export default NoGames;
